import React, { ChangeEvent, KeyboardEvent } from "react";

interface Props {
    value: string;
    onChange: (v: string) => void;
    formSubmitted: boolean;
    disabled: boolean;
    current?: string;
}

const LIMIT = 2500;

export const PromptField = ({ value, onChange, formSubmitted, disabled, current }: Props) => {
    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value.slice(0, LIMIT));
    const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
        const ok = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End"];
        if (value.length >= LIMIT && !ok.includes(e.key) && !e.ctrlKey && !e.metaKey) e.preventDefault();
    };

    return (
        <div>
            <div className="relative">
                <h4 className={`text-lg font-semibold ${disabled ? 'text-gray-400' : 'text-eq-grey'}`}>Prompt Message</h4>
                <span className="absolute right-0 bottom-0 text-xs text-gray-400">
                    {value.length} / {LIMIT}
                </span>
            </div>
            <p className={`text-sm mt-1 mb-4 ${disabled ? 'text-gray-400' : 'text-gray-500'}`}>
                Direct the behavior of the assistant, including its tasks and how it completes them.
            </p>
            {current !== undefined && <p className="text-sm mb-2 text-gray-500">Current Prompt Message: {current}</p>}
            <textarea
                className={`mt-1 block w-full min-h-[150px] rounded-md p-3 border outline-none border-gray-400 focus:border-eq-green focus:ring-eq-green`}
                placeholder={formSubmitted && !value ? "A prompt message is required…" : "Enter prompt message here…"}
                value={value}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                disabled={disabled}
            />
        </div>
    );
};
